import axios from "axios";
import { superAdminApiUrl } from "../util/Constants";
import type { AuditLogEntry, PagedResponse } from "../types/domain";

export interface AuditLogFilters {
  page?: number;
  size?: number;
  action?: string | null;
  username?: string | null;
  from?: string | null; // ISO datetime
  to?: string | null;   // ISO datetime
}

export const auditApi = {
  list: async (filters: AuditLogFilters = {}): Promise<PagedResponse<AuditLogEntry>> => {
    const params: Record<string, string | number> = {
      page: filters.page ?? 0,
      size: filters.size ?? 25,
    };
    if (filters.action) params.action = filters.action;
    if (filters.username) params.username = filters.username;
    if (filters.from) params.from = filters.from;
    if (filters.to) params.to = filters.to;

    const { data } = await axios.get<PagedResponse<AuditLogEntry>>(`${superAdminApiUrl}/audit-log`, { params });
    return data;
  },
};
